export const palette = {
  primary: '#CC4465',
  accent: '#CC4465',
  neutral: '#F2F0EC',
}
